import moment from 'moment';

export default{
    methods: {
        formatDate(date, format){
            let result = moment(date).format(format)

            return result
        }
    }
}